import { useEffect, useState } from 'react'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import { MadeService } from '../../../services/purchase-fuel/made/made.service'
import MadePurchaseTable from '../../../components/purchase-fuel/made/MadePurchaseTable'
import './historic.scss'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'
import { Group } from '@mantine/core'
import AppRangePicker from '../../../component/form/AppRangePicker.tsx'

const Historic = () => {
  const [selectedDateRange, setSelectedDateRange] = useState([
    undefined,
    undefined,
  ])

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'purchaseDate',
    sortInit: -1,
    getAll: ({ filter, sort, limit, skip }) =>
      MadeService.getAll({
        dateFrom: selectedDateRange[0]
          ? new Date(selectedDateRange[0]).toISOString()
          : undefined,
        dateTo: selectedDateRange[1]
          ? new Date(selectedDateRange[1]).toISOString()
          : undefined,
        filter,
        sort,
        limit,
        skip,
      }),
    editAction: MadeService.update,
    removeAction: MadeService.remove,
    rowsPerPageInitial: 100,
  })

  useEffect(() => {
    dataFacade.reload()
  }, [selectedDateRange])

  const headerOptions = {
    title: (
      <Group w="300px">
        <AppRangePicker
          w="100%"
          value={selectedDateRange}
          onChange={setSelectedDateRange}
          clearable
        />
      </Group>
    ),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <MadePurchaseTable
      loading={dataFacade?.loading}
      value={dataFacade?.data?.resp}
      sortOptions={dataFacade?.sortOptions}
      pagerOptions={pagerOptions}
      viewOwnStation
      handleEdit={dataFacade.edit}
      handleDelete={dataFacade.remove}
    />
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      headerOptions={headerOptions}
    >
      {dataTable}
    </AppSection>
  )
}

export default Historic
